document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM fully loaded and parsed');

    // Get all elements that display the one-time unit price
    const oneTimeUnitPriceElements = document.querySelectorAll('.one-time-unit-price');

    // Function to open the cart drawer on page load
    function openCartDrawer() {
        const cartDrawer = document.querySelector('#shtCartDrawer');
        if (cartDrawer) {
            cartDrawer.classList.add('active'); // Ensure the drawer is marked as active
            cartDrawer.setAttribute('aria-hidden', 'false'); // Set ARIA attributes correctly
            cartDrawer.setAttribute('tabindex', '-1'); // Make it focusable
            cartDrawer.setAttribute('open', ''); // Set the open attribute to make the drawer visible

            const cartWrapper = document.querySelector('.js-cart-drawer-wrapper');
            if (cartWrapper) {
                cartWrapper.classList.add('is-open'); // Ensure the wrapper class is added
            }
            document.body.classList.add('drawer-open'); // Prevent body scrolling when drawer is open

            console.log('Cart drawer opened');
        } else {
            console.error('Cart drawer element not found');
        }
    }

    // Open the cart drawer if the flag is set in localStorage
    if (localStorage.getItem('openCartDrawer') === 'true') {
        openCartDrawer();
        // Remove the flag after opening the drawer
        localStorage.removeItem('openCartDrawer');
    }

    // Function to get the value from the sub-disc-label element
    function getSubscriptionDiscountLabel() {
        const labelElement = document.querySelector('.sub-disc-label');
        return labelElement ? labelElement.textContent.trim() : '';
    }

    // Function to get metafield value, designed for fetching subscription plan IDs
    function getMetafieldValue(elementId) {
        const element = document.getElementById(elementId);
        return element ? element.getAttribute('data-value') : null;
    }

    // Function to update subscription dropdown, designed for a ReCharge widget
// Function to update subscription dropdown, designed for a ReCharge widget
function updateSubscriptionDropdown(variantName, variantValue) {
    const subscriptionDropdown = document.querySelector('.rc-selling-plans-dropdown__select');
    const isSubscriptionTab = document.querySelector('.rc-radio.subscription-radio').classList.contains('rc-radio--active');

    if (!subscriptionDropdown) {
        console.log('Subscription dropdown not found');
        return;
    }

    // Mapping variant names to subscription plan IDs
    const subscriptionValueMapping = {
        '14': getMetafieldValue('subscription14DaysPlanId'),
        '28': getMetafieldValue('subscription28DaysPlanId'),
        '6 weeks': getMetafieldValue('subscription6WeeksPlanId'),
        '8 weeks': getMetafieldValue('subscription8WeeksPlanId')
    };

    let subscriptionValue = null;

    // Check for each variant type
    if (variantName.includes('14') || variantName.includes('28')) {
        subscriptionValue = subscriptionValueMapping[variantName.includes('14') ? '14' : '28'];
    } else if ((variantName.includes('6 weeks') || variantName.includes('8 weeks')) && !isSubscriptionTab) {
        // Only allow 6 weeks and 8 weeks in One Time Purchase
        subscriptionValue = null;
        console.log('6 weeks or 8 weeks selected for One Time Purchase tab.');
    } else if ((variantName.includes('6 weeks') || variantName.includes('8 weeks')) && isSubscriptionTab) {
        // Hide 6 weeks and 8 weeks in Subscription
        subscriptionDropdown.value = '';
        console.log('6 weeks or 8 weeks are not allowed in Subscription tab.');
        subscriptionDropdown.dispatchEvent(new Event('change')); // Trigger UI update
        return;
    }

    if (subscriptionValue) {
        subscriptionDropdown.value = subscriptionValue;
        console.log(`Subscription dropdown updated to value: ${subscriptionValue}`);
        subscriptionDropdown.dispatchEvent(new Event('change')); // Trigger UI update
    } else {
        console.log('No subscription value mapped for this variant name.');
    }
}

    // Function to display the correct pricing information based on the selected variant name
    function displayVariantSpecificPricing(selectedVariantName) {
    const isOneTime = document.querySelector('.rc-radio.onetime-radio')?.classList.contains('rc-radio--active');
    
    document.querySelectorAll('.product-variant-prices .variant-price').forEach(function(variantPriceDiv) {
        const variantTitle = variantPriceDiv.querySelector('p').textContent.toLowerCase();
        
        // Check for the base variant type (14 or 28)
        const isMatch = (variantTitle.includes('14') && selectedVariantName.includes('14')) ||
                       (variantTitle.includes('28') && selectedVariantName.includes('28')) ||
                       (variantTitle.includes('6 weeks') && selectedVariantName.includes('6 weeks'));
        
        variantPriceDiv.style.display = isMatch ? 'block' : 'none';
    });
}

    // Function to calculate unit price based on the selected variant value
    function calculateUnitPrice(variantValue, price) {
        return parseFloat(price) / parseFloat(variantValue);
    }

    // Attaches event listener to variant select dropdown for changes
    function attachVariantChangeListener() {
        const variantSelect = document.querySelector('.vars-wrap .field__select select');
        if (!variantSelect) {
            console.log('Variant select not found');
            return;
        }

        variantSelect.addEventListener('change', function() {
            const selectedOption = variantSelect.options[variantSelect.selectedIndex];
            const variantName = selectedOption.text.trim();
            const variantValue = selectedOption.getAttribute('data-metafield-value');
            console.log(`Variant changed to: ${variantName}`);

            setTimeout(function() {
                updateSubscriptionDropdown(variantName, variantValue);
                displayVariantSpecificPricing(variantName);

                // Update unit price for one-time purchase
                oneTimeUnitPriceElements.forEach(function(element) {
                    const oneTimePriceElement = element.parentElement.querySelector('.prod-price-main');
                    if (oneTimePriceElement) {
                        const oneTimePriceText = oneTimePriceElement.textContent.replace('£', '').trim();
                        const oneTimePrice = parseFloat(oneTimePriceText);
                        const variantValueFloat = parseFloat(variantValue);
                        if (!isNaN(oneTimePrice) && !isNaN(variantValueFloat) && variantValueFloat !== 0) {
                            const oneTimeUnitPrice = calculateUnitPrice(variantValueFloat, oneTimePrice).toFixed(2);
                            element.textContent = `Only £${oneTimeUnitPrice} per day`;
                        }
                    }
                });
            }, 100);
        });
    }

// Attaches event listeners to Recharge tabs to toggle pricing display
function attachRechargeTabListeners() {
  document.querySelectorAll('.rc-radio.subscription-radio, .rc-radio.onetime-radio').forEach(tab => {
    tab.addEventListener('click', function() {
      // Detect if subscription is currently selected
      const isSubscriptionActive = document.querySelector('.rc-radio--active.subscription-radio') !== null;
      const isSubscriptionPresent = document.querySelector('.rc-selling-plans') !== null;

      // Toggle active/inactive classes on pricing wraps
      document.querySelectorAll('.prod-prices-wrap').forEach(wrap => {
        if (wrap.id === 'subscription-prices-wrap') {
          wrap.classList.toggle('active', isSubscriptionActive);
          wrap.classList.toggle('inactive', !isSubscriptionActive);
        } else if (wrap.id === 'one-time-prices-wrap') {
          wrap.classList.toggle('active', !isSubscriptionActive);
          wrap.classList.toggle('inactive', isSubscriptionActive);
        }
      });

      // ======================
      // NEW: Toggle Payment Button
      // ======================
      const paymentButton = document.querySelector('div[data-shopify="payment-button"]');
      if (paymentButton) {
        paymentButton.classList.toggle('active', !isSubscriptionActive);
        paymentButton.classList.toggle('inactive', isSubscriptionActive);
      }

      // ======================
      // NEW: Toggle 'sub-selected' on .product__info-wrapper
      // ======================
      const productInfoWrapper = document.querySelector('.product__info-wrapper');
      if (productInfoWrapper) {
        productInfoWrapper.classList.toggle('sub-selected', isSubscriptionActive);
      }
    });
  });
}

    // Safely update the text values for Recharge app tabs
    function safelyUpdateTabTextValues() {
        const subscriptionLabelSelector = '.subscription-radio .discount-label';
        const oneTimeLabelSelector = '.onetime-radio .discount-label';

        const subscriptionDiscountLabel = getSubscriptionDiscountLabel();

        function updateTabTextValues(selector, newText) {
            document.querySelectorAll(selector).forEach(element => {
                if (element.textContent !== newText) {
                    element.textContent = newText;
                }
            });
        }

        updateTabTextValues(subscriptionLabelSelector, `Subscription (${subscriptionDiscountLabel} OFF)`);
        updateTabTextValues(oneTimeLabelSelector, 'One Time Payment');

        // Re-apply text updates if the relevant elements are added to the DOM later
        const config = { childList: true, subtree: true };
        const callback = function(mutationsList, observer) {
            for (let mutation of mutationsList) {
                if (mutation.addedNodes.length) {
                    updateTabTextValues(subscriptionLabelSelector, `Subscription (${subscriptionDiscountLabel} OFF)`);
                    updateTabTextValues(oneTimeLabelSelector, 'One Time Payment');
                }
            }
        };

        const tabObserver = new MutationObserver(callback);
        tabObserver.observe(document.body, config);
    }

    // Start observing changes in the DOM to toggle active/inactive classes on pricing sections
    const pricingObserver = new MutationObserver(function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const isSubscriptionPresent = document.querySelector('.rc-selling-plans') !== null;

                document.querySelectorAll('.prod-prices-wrap').forEach(wrap => {
                    if (isSubscriptionPresent) {
                        wrap.classList.toggle('active', wrap.id === 'subscription-prices-wrap');
                        wrap.classList.toggle('inactive', wrap.id === 'one-time-prices-wrap');
                    } else {
                        wrap.classList.toggle('active', wrap.id === 'one-time-prices-wrap');
                        wrap.classList.toggle('inactive', wrap.id === 'subscription-prices-wrap');
                    }
                });
            }
        }
    });

    pricingObserver.observe(document.body, { subtree: true, childList: true });

    // Function to wait for the subscription dropdown to be available
    function waitForSubscriptionDropdown() {
        const observer = new MutationObserver(function(mutationsList, observer) {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const subscriptionDropdown = document.querySelector('.rc-selling-plans-dropdown__select');
                    if (subscriptionDropdown) {
                        // Subscription dropdown is now available
                        initializeSubscriptionDropdown();
                        // Disconnect the observer to prevent performance issues
                        observer.disconnect();
                        break;
                    }
                }
            }
        });

        // Start observing the document body for additions of child nodes
        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Function to initialize subscription dropdown logic
    function initializeSubscriptionDropdown() {
        const initialVariantSelect = document.querySelector('.vars-wrap .field__select select');
        if (initialVariantSelect) {
            const initialSelectedOption = initialVariantSelect.options[initialVariantSelect.selectedIndex];
            const initialVariantName = initialSelectedOption.text.trim();
            const initialVariantValue = initialSelectedOption.getAttribute('data-metafield-value');
            updateSubscriptionDropdown(initialVariantName, initialVariantValue);
            displayVariantSpecificPricing(initialVariantName);

            // Update unit price for one-time purchase on initial load
            oneTimeUnitPriceElements.forEach(function(element) {
                const oneTimePriceElement = element.parentElement.querySelector('.prod-price-main');
                if (oneTimePriceElement) {
                    const oneTimePriceText = oneTimePriceElement.textContent.replace('£', '').trim();
                    const oneTimePrice = parseFloat(oneTimePriceText);
                    const variantValueFloat = parseFloat(initialVariantValue);
                    if (!isNaN(oneTimePrice) && !isNaN(variantValueFloat) && variantValueFloat !== 0) {
                        const oneTimeUnitPrice = calculateUnitPrice(variantValueFloat, oneTimePrice).toFixed(2);
                        element.textContent = `Only £${oneTimeUnitPrice} per day`;
                    }
                }
            });
        }
    }

    function filterVariantsByPurchaseType() {
        const observer = new MutationObserver(function(mutations, obs) {
            const subscriptionRadio = document.querySelector('.rc-radio.subscription-radio');
            const onetimeRadio = document.querySelector('.rc-radio.onetime-radio');
            const variantSelect = document.querySelector('.vars-wrap .field__select select');
            
            if (subscriptionRadio && onetimeRadio && variantSelect) {
                obs.disconnect();
                
                // Initial filter
                handleVariantFiltering();
                
                // Listen for radio button changes
                document.addEventListener('click', function(e) {
                    if (e.target.closest('.rc-radio')) {
                        setTimeout(handleVariantFiltering, 100);
                    }
                });
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Replace the existing handleVariantFiltering function inside filterVariantsByPurchaseType with this updated version:

function handleVariantFiltering() {
    const subscriptionRadio = document.querySelector('.rc-radio.subscription-radio');
    const onetimeRadio = document.querySelector('.rc-radio.onetime-radio');
    const variantSelect = document.querySelector('.vars-wrap .field__select select');

    if (!subscriptionRadio || !onetimeRadio || !variantSelect) return;

    const isOneTime = onetimeRadio.classList.contains('rc-radio--active');
    const options = variantSelect.querySelectorAll('option');
    let hasValidSelection = false;

    options.forEach(option => {
        const originalText = option.getAttribute('data-original-text') || option.textContent.trim();

        if (!option.getAttribute('data-original-text')) {
            option.setAttribute('data-original-text', originalText);
        }

        const variantName = originalText.toLowerCase();

        if (isOneTime) {
            // Show all variants, including 6 weeks and 8 weeks, under One Time Purchase
            option.style.display = (variantName.includes('6 weeks') || variantName.includes('8 weeks') || 
                                    variantName.includes('14') || variantName.includes('28')) ? '' : 'none';
        } else {
            // Exclude 6 weeks and 8 weeks from Subscription
            option.style.display = (variantName.includes('14') || variantName.includes('28')) ? '' : 'none';
        }

        // Check if the current option is valid and selected
        if (option.style.display === '' && option.selected) {
            hasValidSelection = true;
        }
    });

    // If the current selection is invalid, default to the first valid option
    if (!hasValidSelection) {
        const defaultOption = Array.from(options).find(option => option.style.display === '');
        if (defaultOption) {
            defaultOption.selected = true;
            variantSelect.dispatchEvent(new Event('change'));
        }
    }
}

    }

    // Initialize other functionality
    attachVariantChangeListener();
    attachRechargeTabListeners();
    safelyUpdateTabTextValues();
    waitForSubscriptionDropdown();
    filterVariantsByPurchaseType();
});